import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";


export const onboardingPlanRatesApi = {
  getRecentlyUpdatedPlans: async (
    remoteUtilityId: string,
    limit = 3
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "recently-updated/plan",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("page", "1");
        query.push("limit", limit.toString());
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data);
  },

  getRecentlyUpdatedRates: async (
    remoteUtilityId: string,
    limit = 3
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "recently-updated/rate",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("page", "1");
        query.push("limit", limit.toString());
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data);
  },

  getPlanDashboardData: async (
    remoteUtilityId: string
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "plan/dashboard",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data.result);
  }
};
